export default "__VITE_ASSET__DnnEm0jy__"